export default __webpack_public_path__ + "static/media/kitchen3-afterI-2048w.929b1d08.webp";